import { h, Fragment } from 'preact';
import ChevronDownIcon from 'utils/icon/icon-chevron-down.svg';
import { useEffect, useRef, useState } from 'preact/hooks';
import clsx from 'clsx';
import StoreDetails from './store-details';
import StoreHours from './store-hours';
import { getStoreStatus } from '../utils/helpers';

const StoreItem = ({ listItem = false, location, ...props }) => {
  const content = useRef(null);
  const [isExtended, setIsExtended] = useState(false);
  const locationStatus = getStoreStatus(location);

  useEffect(() => {
    if (content.current) {
      const container = content.current?.parentElement;
      if (isExtended) {
        container.style.maxHeight = `${content.current.offsetHeight}px`;
      } else {
        container.style.maxHeight = `0`;
      }
    }
  }, [isExtended]);

  return (
    <>
      <StoreDetails {...props} location={location} listItem={listItem} />
      {!!listItem && (
        <div className="group">
          <button
            className="text-left w-full px-20 tablet:px-24 py-16 flex gap-12 [&_*]:body-3"
            onClick={() => setIsExtended((extended) => !extended)}
          >
            <span className="flex-1">
              {window.TMW.Strings.storeLocator.hours}:{' '}
              <span
                className={
                  locationStatus?.openNow ? 'text-misc-green' : 'text-error'
                }
                dangerouslySetInnerHTML={{ __html: locationStatus?.summary }}
              ></span>
            </span>
            <ChevronDownIcon
              className={clsx('w-16 flex-none h-auto transition-transform', {
                '-rotate-180': isExtended,
              })}
            />
          </button>
          <div className="transition-all ease-in-out duration-300 overflow-hidden max-h-0">
            <div ref={content}>
              <StoreHours
                {...props}
                location={location}
                locationStatus={locationStatus}
                className="p-24 px-20 tablet:px-24 pb-16 pt-0"
              />
            </div>
          </div>
        </div>
      )}
      {!listItem && (
        <StoreHours
          {...props}
          location={location}
          locationStatus={locationStatus}
          className="pt-16 mt-16 border-t border-grey-300 [&_ul]:p-0"
        />
      )}
    </>
  );
};

export default StoreItem;
